import React from 'react';
import Button from '../../BuildingBlocks/Button/Button';
import CancelButton from '../../BuildingBlocks/Button/CancelButton';
import { makeStyles } from '@material-ui/core/styles';
import { Theme, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    padding: `${theme.spacing(1.25)}px ${theme.spacing(4)}px`,
    borderRadius: theme.spacing(1.5),
    fontSize: 20,
    lineHeight: `${theme.spacing(3)}px`,
  },
  leftButton: {
    marginRight: theme.spacing(2),
  },
  container: {
    display: 'flex',
    justifyContent: 'end',
    marginTop: theme.spacing(5),
  },
}));

interface ActionProps {
  callback: () => void;
  cancelCallback: () => void;
  cancelLabel: string;
  actionLabel: string;
  ctaDisabled: boolean;
  loading: boolean;
}

export default function PlanActivationDialogActions({
  callback,
  cancelCallback,
  cancelLabel,
  actionLabel,
  ctaDisabled = false,
  loading = false,
}: ActionProps) {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <Button
        variant="contained"
        color="primary"
        isLoader={true}
        loading={loading}
        onClick={callback}
        disabled={ctaDisabled}
        className={`${classes.button} ${classes.leftButton}`}
      >
        <Typography variant="h6">
          <b>{actionLabel}</b>
        </Typography>
      </Button>
      <CancelButton
        onCancel={cancelCallback}
        CancelText={cancelLabel}
        className={classes.button}
      />
    </div>
  );
}
